import Swiper, { Pagination, Navigation, Thumbs } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-product-image-carousel]',
  thumbCarouselWrapper: '[data-product-thumb-carousel]',
};

class ProductImageCarousel extends HTMLElement {
  constructor() {
    super();

    this.carouselWrappers = document.querySelectorAll(
      selectors.carouselWrapper
    );

    this.thumbCarouselWrappers = document.querySelectorAll(
      selectors.thumbCarouselWrapper
    );

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(min-width:744px)');

      // Init the carousel on load.
      this.initCarousel();

      // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
      // If not, it will get destroyed.
      this.registerEventListeners();
    });
  }

  initCarousel() {
    if (this.breakpoint.matches) {
      this.thumbCarousel = new Swiper(selectors.thumbCarouselWrapper, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        resizeObserver: true,
        slideToClickedSlide: true,
      });
    }

    this.imageCarousel = new Swiper(selectors.carouselWrapper, {
      modules: [Pagination, Navigation, Thumbs],
      lazy: true,
      loop: true,
      lazyPreloadPrevNext: 2,
      updateOnWindowResize: true,
      resizeObserver: true,
      slideToClickedSlide: true,
      cssMode: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: this.thumbCarousel,
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      // this.initCarousel(); this breaks pagination
    });
  }
}

customElements.define('product-image-carousel', ProductImageCarousel);
